export const pluralizeMeetingType = (name: string): string => {
  const trimmed = name.trim()

  if (!trimmed.toLowerCase().includes('meeting')) {
    return `${trimmed} Meetings`
  }

  return trimmed.toLowerCase().endsWith('s') ? trimmed : `${trimmed}s`
}
